import { filter, mergeMap } from 'rxjs/operators';

import { push } from '../../../app/reducers';
import { FLEET_SELECTION } from '../../../paths';
import { RootEpic } from '../../../store/epics';
import type { ErrorType } from '../../../store/reducers/common';
import { nextStep } from '../../application/reducers/next-step';
import { startOrResumeApplication, startOrResumeApplicationFail, startOrResumeApplicationSuccess } from '../reducers';

const startOrResumeApplicationEpic: RootEpic = (action$, _state$, { api }) => {
  return action$.pipe(
    filter(startOrResumeApplication.match),
    mergeMap(async ({ payload }) => {
      try {
        const fleetRefs = await api.fleetVerification.getFleetRefs();
        const fleetId = fleetRefs.length === 1 ? fleetRefs[0].id : payload?.fleetId;
        if (fleetId) {
          await api.fleetVerification.startVerification({ fleetId });
          return [nextStep({ gotoNextPage: true }), startOrResumeApplicationSuccess()];
        }

        return [push(FLEET_SELECTION), startOrResumeApplicationSuccess()];
      } catch {
        const errorPayload: ErrorType = { message: 'Please try again later, or contact support.' };
        return [startOrResumeApplicationFail(errorPayload)];
      }
    }),
    mergeMap((action) => action),
  );
};

export { startOrResumeApplicationEpic };
